/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["oc",[["AM","PM"]],u,[["S","M","T","W","T","F","S"],["dimenge","diluns","dimars","dimècres","dijòus","divendres","dissabte"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["de genièr","de febrièr","de març","d’abril","de mai","de junh","de julhet","d’agost","de setembre","d’octòbre","de novembre","de decembre"]],u,[["BCE","CE"]],1,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[","," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0 %","#,##0.00¤","#E0"],"EUR","€",u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
